<!--
 * @Author: DY
 * @Date: 2020-08-17 22:01:34
 * @LastEditTime: 2022-11-02 13:56:46
 * @LastEditors: Please set LastEditors
 * @Description: 关联配比
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\productionRatio\correlationRatio_see.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="correlationRatio_see">
            <van-nav-bar
                title="配比详情"
                left-text="查看配比"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section :class="{'showOpinion': isShowOpinion == false}">
                <div class="head">
                    <div class="headContent">
                        <div class="headinfo">
                            <h4>任务编号：{{ task_number }}</h4>
                            <p>
                                <strong class="van_left">{{ productFormula.project_name }}</strong>
                                <span class="van_right">{{ productFormula.place_detail }}</span>
                            </p>
                            <ul>
                                <li>{{ productFormula.strength_grade_name }}</li>
                                <li>{{ productFormula.slump }}</li>
                                <li>{{ productFormula.pouring_name }}</li>
                                <li>{{ productFormula.special_require_name }}</li>
                            </ul>
                        </div>
                        <div class="headBtn">
                            <div>
                                <p>是否出资料：</p>
                                <van-switch
                                    v-model="productFormula.is_datum"
                                    size="20px"
                                    disabled
                                ></van-switch>
                            </div>
                            <div>
                                <p>产生抗压试验：</p>
                                <van-switch
                                    v-model="productFormula.is_testblock"
                                    size="20px"
                                    disabled
                                ></van-switch>
                            </div>
                            <div>
                                <p>试块组数：</p>
                                <input
                                    type="number"
                                    v-model="productFormula.block_group"
                                    placeholder="请输入"
                                    disabled
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <van-tabs :line-width="70" v-model="mixstationlineIndex">
                    <template v-for="(item, index) in mixstationlineData">
                        <van-tab :key="index">
                            <template #title>
                                {{ item.line_name }}
                                <i class="icon toSave" v-if="item.product_formula_number_hjt && !item.sync_status"></i>
                                <i class="icon toSend" v-if="item.sync_status"></i>
                            </template>
                        </van-tab>
                    </template>
                </van-tabs>
                <div class="mixtureRatio">
                    <div class="van_left">
                        <h5>选择配合比类型：</h5>
                        <van-radio-group v-model="formulaTypeChecked" direction="horizontal" icon-size="16">
                            <template v-for="(item,index) in formulaTypeData">
                                <van-radio :name="item.value" :key="index">
                                    {{ item.label }}
                                </van-radio>
                            </template>
                        </van-radio-group>
                    </div>
                </div>
                <div class="scrollArea">
                    <div class="experimentalRatioNo">
                        试验配比名称：{{ productFormulaCount.experiment_formula_name }}
                    </div>
                    <div class="experimentalRatioNo">
                        试验配比编号：{{ productFormulaCount.line_experiment_formula_number }}
                    </div>
                    <div class="proportion">
                        <div>
                            <h5>设计容重</h5>
                            <p>
                                <strong>{{ productFormulaCount.design_volume_weight || 0 }}</strong>
                                <span>kg</span>
                            </p>
                        </div>
                        <div>
                            <h5>实际容重</h5>
                            <p>
                                <strong>{{ productFormulaCount.practical_volume_weight || 0 }}</strong>
                                <span>kg</span>
                            </p>
                        </div>
                        <div style="width: 28%;">
                            <h5>坍落度</h5>
                            <p>
                                <strong>{{ productFormulaCount.slump || 0 }}</strong>
                                <span>mm</span>
                            </p>
                        </div>
                        <div style="width: 22%;">
                            <h5>水胶比</h5>
                            <p>
                                <strong>{{ productFormulaCount.water_binder_ratio || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                        <div>
                            <h5>砂率</h5>
                            <p>
                                <strong>{{ productFormulaCount.sand_rate || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                        <div>
                            <h5>最大粒径</h5>
                            <p>
                                <strong>{{ productFormulaCount.max_particle_size || 0 }}</strong>
                                <span>mm</span>
                            </p>
                        </div>
                        <div style="width: 28%;">
                            <h5>胶凝材料</h5>
                            <p>
                                <strong>{{ productFormulaCount.cementing_material || 0 }}</strong>
                            </p>
                        </div>
                        <div style="width: 22%;">
                            <h5>外加剂掺量</h5>
                            <p>
                                <strong>{{ productFormulaCount.admixture_dosage || 0 }}</strong>
                                <span>%</span>
                            </p>
                        </div>
                    </div>
                    <dl class="matchingInfo">
                        <dt>
                            <p>配比信息</p>
                            <span>（点击料仓设置配比信息）</span>
                        </dt>
                        <dd>
                            <template v-for="(item, index) in matchingInfoData">
                                <div :key="index" @click="openPage(item,index)">
                                    <p class="name">
                                        <strong>{{ item.plcw || '-' }}/{{ item.plcwname || '-' }}</strong>
                                    </p>
                                    <p class="value">
                                        <span class="construction">施工:{{ item.product_quantity || 0 }}</span>
                                        <span class="difference">差值:{{ item.difference_value || 0 }}%</span>
                                        <span class="actualConsumption">实际:{{ item.gk_quantity || 0 }}</span>
                                        <span class="waterContent" v-if="item.stock_category == 'F3-01-XN-01'">
                                            含水率:{{ item.moisture_ratio || 0 }}%
                                        </span>
                                    </p>
                                    <p class="materialScience">
                                        {{ item.stock_category_name || '-' }}/{{ item.material_child_name || '-' }}/{{ item.material_name || '-' }}
                                    </p>
                                </div>
                            </template>
                        </dd>
                    </dl>
                </div>
            </section>
            <footer class="seeScene" :class="{'hideOpinion': !isShowOpinion}">
                <button
                    class="iconfont iconfujian-fill opinionButton"
                    @click="openApprovalComments"
                    v-if="isShowOpinion"
                >
                    意见
                </button>
            </footer>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 关联配比
    name: 'correlation-ratio-see',
    components: {},
    props: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/productionRatio') {
            this.$store.commit('noKeepAlive', 'correlation-ratio-see');
        }
        next();
    },
    data() {
        return {
            // 任务单号
            task_number: '',
            // 任务列表下标
            listIndex: 0,
            // 施工配比基本信息
            productFormula: {
                // 工程名称 
                project_name: '',
                // 工程部位
                place_detail: '',
                // 是否出资料
                is_datum: false,
                // 产生抗压试验
                is_testblock: false,
            },
            // 全部生产机组
            mixstationlineData: [],
            // 当前选中机组下标
            mixstationlineIndex: 0,
            // 当前选中机组
            mixstationChecked: null,
            // 全部配比类型
            formulaTypeData: [
                {
                    label: '砼配比',
                    value: 0,
                },
                {
                    label: '润泵砂浆配比',
                    value: 1,
                },
            ],
            // 选中配合比类型
            formulaTypeChecked: 0,
            // 选择配比类型（0试验配比，1原试验配比）
            selectRatioType: null,
            // 机组下基础信息
            productFormulaCount: {},
            // 配比信息数据
            matchingInfoData: [],
            // 审批意见按钮权限
            isShowOpinion: false,
        };
    },
    created() {
        // 任务单号
        this.task_number = this.$route.params.task_number;
        // 任务列表下标
        this.listIndex = this.$route.params.listIndex;
        // 初始化页面数据
        this.getInit();
    },
    mounted() { },
    activated() {},
    update() { },
    beforeRouteUpdate() { },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 初始化页面数据
        getInit() {
            this.$axios
                .get(`/interfaceApi/production/productformula/formula_info_real/${this.task_number}`)
                .then(res => {
                    if (res.productFormula.is_approval_formula) {
                        this.isShowOpinion = true;
                    }

                    // 基本信息赋值
                    this.productFormula = res.productFormula;
                    // 生产机组赋值
                    this.mixstationlineData = res.productFormulaLine;
                    if (!this.mixstationChecked) {
                        this.mixstationChecked = this.mixstationlineData[0].line_code;
                        this.mixstationChange();
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 过滤当前产线数据
        mixstationChange() {
            const tableData = this.mixstationlineData.filter(item => {
                return item.line_code === this.mixstationChecked;
            });
            if (tableData.length > 0) {
                if (this.formulaTypeChecked === 0) {
                    if (tableData[0].product_formula_hjt) {
                        this.productFormulaCount = tableData[0].product_formula_hjt;
                        this.matchingInfoData = tableData[0].product_formula_hjt.productFormulaEntityOutputs;
                    } else {
                        this.matchingInfoData = [];
                        this.productFormulaCount = {};
                    }
                } else if (this.formulaTypeChecked === 1) {
                    if (tableData[0].product_formula_sj) {
                        this.productFormulaCount = tableData[0].product_formula_sj;
                        this.matchingInfoData = tableData[0].product_formula_sj.productFormulaEntityOutputs;
                    } else {
                        this.matchingInfoData = [];
                        this.productFormulaCount = {};
                    }
                }
            } else {
                this.matchingInfoData = [];
                this.productFormulaCount = {};
            }
            if ((this.productFormulaCount.productFormulaRelExperimentOutputs || []).length > 0) {
                this.selectRatioType = 0;
            } else {
                this.selectRatioType = 1;
            }
        },
        // 打开料仓配比信息设置
        openPage(data, index) {
            let matchingData = null;
            if (this.selectRatioType === 0) {
                // eslint-disable-next-line max-len
                matchingData = this.productFormulaCount.productFormulaRelExperimentOutputs.filter(item => item.stock_category === data.stock_category)[0];
            }
            this.$router.isBack = 2;
            this.$router.push({
                name: 'matchingInfoSetting',
                params: {
                    isReadOnly: true,
                    data: data,
                    matchingData: matchingData,
                    index: index,
                },
            });
        },
        // 审批意见
        openApprovalComments() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'mixtureRatioApprovalOpinion',
                params: {
                    task_number: this.task_number,
                },
            });
        },
    },
    filter: {},
    computed: {},
    watch: {
        mixstationlineIndex(newVal) {
            this.mixstationChecked = this.mixstationlineData[newVal].line_code;
            this.mixstationChange();
        },
        formulaTypeChecked() {
            this.mixstationChange();
        },
    },
};
</script>

<style lang="stylus" scoped>
.correlationRatio_see
    height 100%
    section
        height calc(100% - 114rpx)
        &.showOpinion
            height calc(100% - 50rpx)
        .head
            height 160rpx
            position relative
            &:after
                height 92rpx
                content ''
                position absolute
                top 0
                left 0
                width 100%
                background #2b5dab
            .headContent
                width 345rpx
                height 159rpx
                background url(images/bg@2x.png) no-repeat
                background-size 100% 100%
                position absolute
                top 0
                left 50%
                transform translateX(-50%)
                z-index 9
                .headinfo
                    height 92rpx
                    padding 10rpx 15rpx
                    h4
                        font-size 16rpx
                        color #3495FB
                    p
                        overflow hidden
                        line-height 32rpx
                        strong
                            font-size 16rpx
                            font-weight 500
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            width 60%
                        span
                            font-size 14rpx
                            color #666666
                            text-align right
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            width 30%
                    ul
                        overflow hidden
                        li
                            float left
                            width 60rpx
                            font-size 12rpx
                            line-height 20rpx
                            margin-right 10rpx
                            text-align center
                            &:nth-of-type(1)
                                color #5588F1
                                background rgba(85,136,241,0.06)
                            &:nth-of-type(2)
                                color #FA8436
                                background rgba(250,132,54,0.06)
                            &:nth-of-type(3)
                                color #21BDCC
                                background rgba(33,189,204,0.06)
                            &:nth-of-type(4)
                                color #866BEE
                                background rgba(134,107,238,0.06)
                .headBtn
                    display flex
                    padding 8rpx 15rpx 0
                    >div
                        flex 4
                        p
                            font-size 14rpx
                            line-height 14rpx
                            margin-bottom 7rpx
                            color #333333
                            white-space nowrap
                        input
                            width 60rpx
                            height 30rpx
                            font-size 14rpx
                            text-align center
                            border 1px solid #D7D7D7
                        &:nth-of-type(3)
                            flex 2
                            p
                                margin-bottom 2rpx
        .van-tabs
            width 100%
            .van-tab__text
                i
                    display inline-block
                    width 20rpx
                    height 20rpx
                    &.toSave
                        background url(images/save@2x.png) no-repeat
                        background-size 100% 100%
                    &.toSend
                        background url(images/send@2x.png) no-repeat
                        background-size 100% 100%
        .mixtureRatio
            height 60rpx
            padding 10rpx 15rpx 0 15rpx
            font-size 14rpx
            color #333333
            overflow hidden
            h5
                margin-bottom 6rpx
            .van-radio-group
                .van-icon
                    font-size 16rpx
                .van-radio__label
                    font-size 14rpx
                    line-height 16rpx
            .van_right
                width 93rpx
                height 34rpx
                margin 8rpx 0
                border-radius 4px
                border 1px solid #3094FB
                text-align center
                color #3094FB
                font-size 14rpx
                p,i
                    display inline-block
                    font-size 14rpx
                    line-height 32rpx
                    color #3094FB
                i
                    margin-left 5rpx
        .scrollArea
            height calc(100% - 260rpx)
            overflow-y auto
            .experimentalRatioNo
                font-size 14rpx
                line-height 14rpx
                margin 10rpx 15rpx
                color #666666
            .proportion
                margin 0 15rpx
                height 90rpx
                padding 0 10rpx
                background rgba(255,255,255,1)
                box-shadow 1px 1px 4px 0px rgba(85,136,241,0.5)
                border-radius 4px
                border 1px solid rgba(215,215,215,1)
                display flex
                flex-wrap wrap
                justify-content space-between
                >div
                    width 25%
                    margin 5rpx 0
                    h5
                        font-size 10rpx
                        color #979EA7
                        line-height 15rpx
                        margin-bottom 3rpx
                    p
                        line-height 14rpx
                        strong
                            font-size 14rpx
                            font-weight 400
                        span
                            font-size 10rpx
                    &:nth-of-type(1)
                        p
                            color #5588F1
                    &:nth-of-type(2)
                        p
                            color #EB656F
                    &:nth-of-type(3)
                        p
                            color #21BDCC
                    &:nth-of-type(4)
                        p
                            color #FA8436
                    &:nth-of-type(5)
                        p
                            color #866BEE
                    &:nth-of-type(6)
                        p
                            color #71C6B0
                    &:nth-of-type(7)
                        p
                            color #32C5FF
                    &:nth-of-type(8)
                        p
                            color #6DD400
            .matchingInfo
                dt
                    margin 10rpx 15rpx
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                    overflow hidden
                    span,p
                        float left
                    span
                        font-size 14rpz
                        color #979EA7
                dd
                    padding 0 11rpx
                    height calc(100% - 36rpx)
                    overflow scroll
                    -webkit-overflow-scrolling: touch;
                    div
                        float left
                        margin 0 4rpx 8rpx 4rpx
                        width calc(50% - 8rpx)
                        padding 5rpx
                        border 1px solid #D7D7D7
                        .name
                            overflow hidden
                            line-height 16rpx
                            strong
                                font-size 12rpx
                                color #333333
                        .value
                            margin-top 5rpx
                            display flex
                            flex-wrap wrap
                            justify-content space-between
                            span
                                width calc(50% - 2rpx)
                                height 20rpx
                                line-height 20rpx
                                font-size 12rpx
                                padding 0 5rpx
                                margin-bottom 4rpx
                            .construction
                                color #FA8436
                                background rgba(250, 132, 54, 0.1)
                            .difference
                                color #866BEE
                                background rgba(134, 107, 238, 0.1)
                            .actualConsumption
                                color #5588F1
                                background rgba(85, 136, 241, 0.1)
                            .waterContent
                                color #21BC9A
                                background rgba(33, 188, 154, 0.1)
                        .materialScience
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 12rpx
                            color #666666
    footer
        display flex
        justify-content space-between
        height 70rpx
        padding 15rpx
        &.seeScene
            justify-content center
            .opinionButton
                width 100%
        &.hideOpinion
            display block
            div
                width 100%
                button
                    width 50%
        button
            width 50%
            height 40rpx
            font-size 16rpx
        .opinionButton
            width 100rpx
            background #5588F1
            border none
            color #fff
            border-radius 4rpx
        div
            button
                width 110rpx
                height 40rpx
                background #fff
                font-size 16rpx
                color #E50C0D
                border 1px solid #E50C0D
                &:before
                    padding-right 5rpx
                &:nth-of-type(1)
                    border-radius 4rpx 0 0 4rpx
                &:nth-of-type(2)
                    background #E50C0D
                    color #fff
                    border-radius 0 4rpx 4rpx 0
    .van-popup
        border-radius 4px
        overflow hidden
    .selectCrew
        width 345rpx
        h3
            font-size 14rpx
            line-height 30rpx
            height 30rpx
            text-align center
            color #fff
            background linear-gradient(315deg,rgba(85,167,254,1) 0%, rgba(62,121,197,1) 100%)
        ul
            padding 15rpx
            padding-bottom 0
            max-height 320rpx
            overflow scroll
            -webkit-overflow-scrolling touch
            li
                width 100%
                height 75px
                overflow hidden
                border-radius 4px
                margin-bottom 10rpx
                border 1px solid rgba(215,215,215,1)
                .cornerMarker
                    position absolute
                    width 40rpx
                    height 40rpx
                    top 0
                    right 0
                    color #979EA7
                    &:before
                        font-size 40rpx
                        line-height 40rpx
                        position absolute
                        top 0
                    i
                        font-size 16rpx
                        font-weight 600
                        position absolute
                        top 4rpx
                        right 4rpx
                        color #fff
                .crewName
                    width 40rpx
                    height 100%
                    background #F0F7FF
                    color #333333
                    position relative
                    .cornerMarker
                        width 30rpx
                        height 30rpx
                        left 0
                        right auto
                        color #E2ECF8
                        &:before
                            font-size 30rpx
                            line-height 30rpx
                        i
                            font-size 12rpx
                            left 3rpx
                            top 3rpx
                            right auto
                            color #AFBED1
                    .name
                        display inline-block
                        width 100%
                        font-size 13rpx
                        padding 8rpx
                        text-align center
                        position absolute
                        left 50%
                        top 50%
                        transform translate(-50%, -50%)
                .crewDetails
                    width calc(100% - 40rpx)
                    height 100%
                    padding 8rpx 14rpx
                    position relative
                    p
                        overflow hidden
                        i,span
                            float left
                        i
                            margin 5rpx 5rpx 0 0
                            width 16rpx
                            height 16rpx
                            background url(./../../../assets/images/icons/icon_gy_1.png) no-repeat
                            background-size auto 100%
                        span
                            width calc(100% - 30rpx)
                            overfloe hidden
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            line-height 26rpx
                            color #333333
                    .cornerMarker
                        i
                            font-size 10rpx
                            top 8rpx
                            right -2rpx
                            color #fff
                            font-weight 100
                            transform rotate(45deg)
                &.active
                    border 2px solid #54A5FB
                    .crewName
                        background #3495FB
                        color #fff
                    .cornerMarker_l
                        color #027DFE
                        i
                            color #fff
                &.associated
                    .cornerMarker_r
                        color #FA8436
        .btns
            margin-top 15rpx
            height 50rpx
            text-align center
            button
                border none
                font-size 14rpx
                color #fff
                width 80px
                height 34px
                background linear-gradient(135deg,rgba(58,150,254,1) 0%, rgba(64,182,255,1) 100%)
                border-radius 4px
</style>
